import { type StandardEventProperties, track } from '@betterment/js-runtime';

export function trackClick(properties: StandardEventProperties): void {
  track('ElementClicked', { interaction: 'click', ...properties });
}
